import { CANONICAL_MINTS } from "./stops.js";
/**
 * Orca legacy-sdk `toBaseQuoteOrder` quote priority (utils/public/pool-utils.ts); any other mint is
 * 0. Kept separate from `CANONICAL_MINTS`, which drives the catalog allowlist and valuation.
 */
export const ORCA_QUOTE_PRIORITY = {
    [CANONICAL_MINTS.USDT]: 100,
    [CANONICAL_MINTS.USDC]: 90,
    USDH1SM1ojwWUga67PGrgFWUHibbjqMvuMaDkRJTgkX: 80,
    [CANONICAL_MINTS.SOL]: 70,
    mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So: 60,
    "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj": 50,
};
function priority(mint) {
    return Object.hasOwn(ORCA_QUOTE_PRIORITY, mint) ? (ORCA_QUOTE_PRIORITY[mint] ?? 0) : 0;
}
/**
 * `inverted` is true when on-chain token A is the quote, i.e. prices display as A per B. A tie keeps
 * A base, B quote (Orca's stable sort).
 */
export function quoteOrder(mintA, mintB) {
    const inverted = priority(mintA) > priority(mintB);
    return inverted
        ? { inverted, baseMint: mintB, quoteMint: mintA }
        : { inverted, baseMint: mintA, quoteMint: mintB };
}
/**
 * "BASE / QUOTE" — the only producer of a pair name. `inverted` defaults to the rule; the web's
 * `priceFrame` passes the wizard's live toggle so its heading names the frame it prints in.
 */
export function pairLabel(tokenA, tokenB, inverted = quoteOrder(tokenA.mint, tokenB.mint).inverted) {
    const [base, quote] = inverted ? [tokenB, tokenA] : [tokenA, tokenB];
    return `${base.symbol} / ${quote.symbol}`;
}
/** "QUOTE per BASE" — the only producer of a price unit. */
export function unitLabel(tokenA, tokenB, inverted = quoteOrder(tokenA.mint, tokenB.mint).inverted) {
    const [base, quote] = inverted ? [tokenB, tokenA] : [tokenA, tokenB];
    return `${quote.symbol} per ${base.symbol}`;
}
